import React from "react";

type Props = {
  label: string;
  name: string;
  value: string;
  checked: boolean;
  onChange: (value: string) => void;
};

const RadioInput: React.FC<Props> = ({
  label,
  name,
  value,
  checked,
  onChange,
}) => {
  return (
    <div className="form-check form-check--choice">
      <input
        id={`${name}-${value}`}
        type="radio"
        name={name}
        value={value}
        className="form-check-input"
        checked={checked}
        onChange={() => onChange(value)}
      />
      <label className="form-check-label" htmlFor={`${name}-${value}`}>{label}</label>
    </div>
  );
};

export default RadioInput;
